import { render, staticRenderFns } from "./GetBuildingMaterials.vue?vue&type=template&id=8c1eb6f6"
import script from "./GetBuildingMaterials.vue?vue&type=script&lang=js"
export * from "./GetBuildingMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports